import type {
  Account,
  InventoryResource,
  Snapshot,
  AzureDisk,
} from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { AzureDiskConfiguration } from './steps/azureDiskConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreAzureDiskState {
  resourceId: string;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  resourceGroup?: string;
  location?: string;

  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags?: boolean;
  initialDiskSettings: AzureDisk;
  diskSettings?: AzureDisk;
  keepOriginalSettings?: boolean;
}

const restoreAzureDiskFlow: Step<RestoreAzureDiskState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'AzureDiskConfiguration',
      Component: AzureDiskConfiguration,
    },
  ],
};

export const RestoreAzureDiskWizard = ({
  resource,
  snapshot,
  disk,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  disk: AzureDisk;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreAzureDiskState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreAzureDiskFlow]}
      initialState={{
        snapshot,
        resourceId: resource.id,
        location: resource.region,
        supportedCloudProviders: [Provider.Azure],
        initialDiskSettings: disk,
        tags: snapshot.resource?.tags || {},
        initialTags: snapshot.resource?.tags || {},
        keepOriginalTags: true,
        keepOriginalSettings: true,
      }}
      title={`Restore Disk`}
      stepperLabels={['Restore account', 'Disk configuration']}
    />
  );
};
